import type { FeatureFlagT } from '../proctor/FeatureFlags';

import { useContext, createContext } from 'react';

export const FeatureFlagContext = createContext<FeatureFlagT>({} as FeatureFlagT);

export const useFeatureFlags = () => {
    return useContext(FeatureFlagContext);
};
